import cyrillicLatinLetters from '../data/cyrillic-latin.json';

const createURLChunk = (value, isAnchorLink = false) => {
  let URLChunkInCyrillic = '';
  let URLChunkInLatin = isAnchorLink ? '' : '/';

  // STEP 1. Get only letters and "-" sign in Russian
  URLChunkInCyrillic = value
    .toLowerCase()
    .match(/[а-я\s]/g)
    .join('');

  // STEP 2. Translate an URL chunk from Cyrillic to Latin
  URLChunkInCyrillic.split('').forEach((valueLetter) => {
    return cyrillicLatinLetters.forEach((dictionaryLetter) => {
      if (valueLetter === dictionaryLetter.cyrillic) {
        return (URLChunkInLatin += dictionaryLetter.latin);
      }
    });
  });

  return URLChunkInLatin;
};

export default createURLChunk;
